import { useNavigate } from "react-router-dom";

export default function ResetSuccess() {
    const navigate = useNavigate()
    setTimeout(() => {
      navigate("/");
      }, 3000);
  return (
    <div className="TotalContainer d-md-flex">
    {/* <div className='MainContainer col-12 p-0   '> */}

    <div className="banner_box col-lg-3 col-md-5 col-12 m-0 p-0">
      <img
        className="banner_img "
        src="/LoginRegister/BannerImg.png"
        alt="banner img"
      ></img>
    </div>
    <div className="successDiv2">
      <img
        className=""
        src="/LoginRegister/SuccessReset.svg"
        alt="success img"
      ></img>
    </div>

    {/* </div> */}
  </div>
  )
}